module.exports = __webpack_public_path__ + "img/IMG_0374_L_Foamcore.9cbe98e0.jpg";